/**
 * Controller: DonationsConfigCreateModal
 */
angular.module('acme.view.application.donations.config.createModal.controllers', [
  'ui.bootstrap',
  'acme.common.service.templates'
])
.controller('DonationsConfigCreateModalController', [ '$scope', '$uibModalInstance', 'TemplatesService', 'currentType', 'list', 'currentItem', function($scope, $uibModalInstance, TemplatesService, currentType, list, currentItem) {

  $scope.errors = [];

  $scope.mode = 'create';
  $scope.title = 'Create';
  $scope.type = currentType;
  $scope.showPrice = true;

  $scope.model = {
    name: '',
    description: '',
    isDefault: false,
    online: true,
    csr: true,
    pos: true,
    insideSalesIndividual: true,
    salesChannels: []
  };

  $scope.init = function() {
    if (currentItem) {
      $scope.mode = 'edit';
      $scope.title = 'Edit';
      $scope.model = currentItem;
    }

    $scope.model.salesChannels = TemplatesService.orderSalesChannels(angular.copy(TemplatesService.salesChannels));

    $scope.setSalesChannels();
  };

  $scope.setSalesChannels = function () {
    angular.forEach($scope.model.salesChannels, function(item, index) {
      switch (item.channel) {
        case 'online':
          $scope.model.salesChannels[index].enabled = $scope.model.online;
          break;
        case 'pointOfSale':
          $scope.model.salesChannels[index].enabled = $scope.model.pos;
          break;
        case 'customerRep':
          $scope.model.salesChannels[index].enabled = $scope.model.csr;
          break;
      }
    });
  };

  $scope.getSalesChannels = function () {
    angular.forEach($scope.model.salesChannels, function(item, index) {
      switch (item.channel) {
        case 'online':
          $scope.model.online = $scope.model.salesChannels[index].enabled;
          break;
        case 'pointOfSale':
          $scope.model.pos = $scope.model.salesChannels[index].enabled;
          break;
        case 'customerRep':
          $scope.model.csr = $scope.model.salesChannels[index].enabled;
          break;
      }
    });
  };

  $scope.isMode = function(mode) {
    return ($scope.mode === mode);
  };

  $scope.hasErrors = function() {
    return ($scope.errors.length > 0);
  };

  $scope.trim = function(s) {
    return s.replace(/\s+/g, '').toLowerCase();
  };

  $scope.isUnique = function() {
    var i, ii,
      trimmed,
      trimmedCurrent = $scope.trim($scope.model.name),
      r = true;


    for (i=0,ii=list.length;i<ii;i++) {
      trimmed = $scope.trim(list[i].name);
      if (trimmedCurrent === trimmed) {
        r = false;
        break;
      }
    }

    return r;

  };

  $scope.isDonationConfigSalesChannel = function (channel) {
    var r = true;
    if (channel === 'manualEntry' || channel === 'reseller' || channel === 'kiosk') {
      r = false;
    }
    return r;
  };

  $scope.done = function() {
    if ($scope.isMode('create')) {
      if ($scope.isUnique()) {
        if ($scope.model.name.replace(/\s+/g, '').length > 0) {
          $scope.success();
        } else {
          $scope.errors.push({message: 'Please enter a valid name'});
        }
      } else {
        $scope.errors.push({message: 'The name "' + $scope.model.name + '" already exists'});
      }
    }else if ($scope.isMode('edit')) {
      if ($scope.model.name.replace(/\s+/g, '').length > 0) {
        $scope.success();
      } else {
        $scope.errors.push({message: 'Please enter a valid name'});
      }
    }
  };

  $scope.cancel = function () {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.success = function () {
    $scope.getSalesChannels();
    $uibModalInstance.close($scope.model);
  };

  $scope.init();

}]);
